import { AxiosResponse } from 'axios';

import api from '~api/api';

export default {
  /*
   * Api-Call which will get the banner-images array
   */
  async getByVoucherCategoryId(
    voucherCategoryId: string | number,
    params: object | undefined,
  ): Promise<AxiosResponse> {
    return api.get(`/voucher-categories/${voucherCategoryId}/banners`, { params });
  },
};
